module.exports = __webpack_public_path__ + "img/bingo_ball-71.c67eb097.png";